import { IHttpApi } from '@cian/http-api/shared';

import {
  fetchAddFavorite,
  TAddFavoriteRequest,
  TAddFavoriteResponse,
} from '../../../repositories/favorites/v1/add-favorite';
import { assertUnknownError } from './assert';
import { IAddFavorite } from '../../../types/favorite';

export async function addFavoriteRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: Omit<TAddFavoriteRequest, 'dealType' | 'entityType'>;
}): Promise<IAddFavorite> {
  const response: TAddFavoriteResponse = await fetchAddFavorite({
    httpApi,
    parameters: { dealType: 'sale', entityType: 'offerResidental', ...parameters },
  });

  assertUnknownError(response);

  return response.response;
}
